<template>
  <div class="Inicio">
    <div class="banner">
      <div class="mainContent">
        <p style="width: 700px; margin-top: 60px;">
          Solicita hoy tu préstamo y<br />
          cumple tus objetivos<br />
          Monto de hasta $1200000
        </p>
        <a
          target="blank"
          href="https://play.google.com/store/apps/details?id=cash.money.loan.coin.dinerbacano"
          class="playBtn"
          ><img src="@/assets/image/playBtn.webp" alt=""
        /></a>
      </div>
    </div>

    <div class="p3 mainContent">
      <div class="title">Nuestras ventajas</div>
      <div class="content">
        <div class="item">
          <div class="item-title">
            <h1>Comprobación de elegibilidad en tiempo real</h1>
            <p>
              Con nuestro avanzado sistema automatizado, la<br />
              aprobación de tu préstamo se procesa en cuestión de<br />
              segundos, lo que te permitirá saber de forma instantánea<br />
              si eres elegible para solicitar un préstamo de hasta $1200000.
            </p>
          </div>
          <img src="@/assets/image/p3_1.webp" alt="" />
        </div>
        <div class="item">
          <img src="@/assets/image/p3_2.webp" alt="" />
          <div class="item-title">
            <h1>Depósito en cualquier hora del día</h1>
            <p>
              Nuestro sistema de transferencias de dinero está diseñado<br />
              para brindarte una experiencia sin interrupciones, disponible<br />
              24/7.
            </p>
            <p>
              Con la confianza de saber que nuestro sistema siempre está<br />
              disponible, puedes estar seguro de que podemos satisfacer<br />
              tus necesidades bancarias en cualquier momento del día o de<br />
              la noche.
            </p>
          </div>
        </div>
        <div class="item">
          <div class="item-title">
            <h1>Nuestro proceso de préstamo es rápido y sencillo</h1>
            <p>
              Nuestra solicitud de transferencia de dinero se puede<br />
              completar en línea, desde la comodidad de tu hogar o<br />
              cualquier otro lugar en el que te encuentres, y solo lleva<br />
              unos minutos de tu tiempo.
            </p>
          </div>
          <img src="@/assets/image/p3_3.webp" alt="" />
        </div>
        <div class="item">
          <img src="@/assets/image/p3_4.webp" alt="" />
          <div class="item-title">
            <h1>Protección de datos de nuestros clientes</h1>
            <p>
              Todos los datos son procesados y almacenados en<br />
              servidores seguros con altos estándares de seguridad,<br />
              utilizando técnicas bancarias para la protección de datos<br />
              tanto en reposo como en tránsito. Nuestro compromiso es<br />
              mantener la privacidad de los datos de nuestros clientes en<br />
              todo momento.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="p4">
      <div class="mainContent">
        <div class="title">Pasos para solicitar</div>
        <div class="content">
          <div>
            <div class="item">
              <img src="@/assets/image/p4_1.webp" alt="" style="width:105px" />
              <div class="item-title">
                <h1>Obtén nuestra APP</h1>
                <p>
                  Descarga la aplicación oficial en Play Store
                </p>
              </div>
            </div>
            <div class="item">
              <img src="@/assets/image/p4_2.webp" alt="" style="width:119px" />
              <div class="item-title">
                <h1>Completa tu solicitud</h1>
                <p>
                  Rellena un pequeño cuestionario donde no<br />
                  tardarás más de 5 minutos
                </p>
              </div>
            </div>
          </div>
          <div>
            <div class="item">
              <img src="@/assets/image/p4_3.webp" alt="" style="width:148px" />
              <div class="item-title">
                <h1>Verificación de solicitud</h1>
                <p>
                  Este proceso se realizará de manera<br />
                  automática por nuestra plataforma de alta<br />
                  tecnología
                </p>
              </div>
            </div>
            <div class="item">
              <img src="@/assets/image/p4_4.webp" alt="" style="width:125px" />
              <div class="item-title">
                <h1>Depósito a su cuenta</h1>
                <p>
                  El depósito se realiza al momento en cuanto<br />
                  su solicitud sea aprobada
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p5" id="target">
      <div class="mainContent">
        <div>
          <h1>Conoce nuestra empresa</h1>
          <p>
            Como empresa con productos financieras, nuestro<br />
            objetivo es ayudar a nuestros usuarios a superar<br />
            fácilmente sus dificultades y necesidades financieras<br />
            urgentes usando nuestro modelo de big data y<br />
            pruebas para controles de riesgo.<br />
            Diferenciamos por procesos de aprobación<br />
            automática y rápida, y guardamos firmemente la<br />
            seguridad de sus datos personales.
          </p>
        </div>
        <img src="../assets/image/p5_2.webp" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/Inicio.scss";

export default {
  name: "Inicio",
  data() {
    return {
      changeNum: 0,
      sliderValue: 5000,
      currentdate: "",
      addDate: "",
      isActive: 61,
    };
  },
  created() {
    this.getNowFormatDate();

  },
  mounted(){
    if (this.$route.query.value) {
      console.log(this.$route.query.value)

      const target = document.querySelector("#target");
      window.scrollTo({ top: target.offsetTop, behavior: "smooth" });
    }
  },
  watch: {
    $route(value) {
      console.log(111);
      if (value.query.value) {
        const target = document.querySelector("#target");
        window.scrollTo({ top: target.offsetTop, behavior: "smooth" });
      }
    },
  },
  methods: {
    changeList(index) {
      this.changeNum = index;
    },
    getDays(day) {
      this.isActive = day;
      this.dateAddDays(this.currentdate, day);
    },
    dealNumber(num) {
      if (num != 0 && num) {
        num = num + "";
        let splitList = num.split(".");
        //将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
        let intStrList = splitList[0]
          .split("")
          .reverse()
          .join("")
          .match(/(\d{1,3})/g);
        //将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
        let intStr = intStrList
          .join(",")
          .split("")
          .reverse()
          .join("");
        return intStr;
      }
      return num;
    },
    dateAddDays(dateStr, dayCount) {
      var tempDate = new Date(dateStr.replace(/-/g, "/")); //把日期字符串转换成日期格式
      var resultDate = new Date((tempDate / 1000 + 86400 * dayCount) * 1000); //增加n天后的日期
      let mounth = (resultDate.getMonth() + 1).toString();
      if (mounth.length == 1) {
        mounth = "0" + mounth;
      }
      let today = resultDate.getDate().toString();
      if (today.length == 1) {
        today = "0" + today;
      }

      var resultDateStr = today + "-" + mounth + "-" + resultDate.getFullYear(); //将日期转化为字符串格式
      this.addDate = resultDateStr;
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      this.currentdate = currentdate;
      this.getDays(90);
    },
  },
};
</script>

<style scoped lang="scss"></style>
